import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432a4112"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "security-msg-box-root" }
const _hoisted_2 = { class: "security-msg-box-wrap" }
const _hoisted_3 = { class: "security-body-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "security-msgbox-title-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "修改密码"),
  /*#__PURE__*/_createElementVNode("div", { class: "bar-line" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-text" }, " 为了您的账号安全，建议您初次登录时重设密码，密码不得少于6位，且需字母和数字的组合. ", -1))
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "旧密码", -1))
const _hoisted_8 = { class: "input-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "新密码", -1))
const _hoisted_10 = { class: "input-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "确认密码", -1))
const _hoisted_12 = { class: "error" }
const _hoisted_13 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldPassword) = $event))
          }, null, 512), [
            [_vModelText, _ctx.oldPassword]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event))
          }, null, 512), [
            [_vModelText, _ctx.newPassword]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event))
          }, null, 512), [
            [_vModelText, _ctx.confirmPassword]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["prevent"]))
          }, "确定")
        ])
      ])
    ])
  ]))
}